import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./components/Home";
import Listing from "./components/Listing";
import Admin from "./components/Admin";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "Bellani Consórcios";
    // Guard against any runtime script resetting the tab title
    const interval = setInterval(() => {
      if (document.title !== "Bellani Consórcios") {
        document.title = "Bellani Consórcios";
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/imovel" element={<Listing segmento="imovel" />} />
          <Route path="/veiculo" element={<Listing segmento="veiculo" />} />
          <Route path="/todos" element={<Listing segmento="todos" />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
